import type { Router } from "vue-router";
import {
  LESSON_CLASS_ROUTE_NAMES,
  MENTOR_CLASS_ROUTE_NAMES,
} from "./routeNames";

export type ClassroomSection = "mentor" | "lesson";

const STORAGE_KEY = "classroom-last-tab";

const TAB_ROUTE_NAMES: Record<ClassroomSection, readonly string[]> = {
  mentor: Object.values(MENTOR_CLASS_ROUTE_NAMES).filter(
    (name) => name !== MENTOR_CLASS_ROUTE_NAMES.MAIN,
  ),
  lesson: Object.values(LESSON_CLASS_ROUTE_NAMES).filter(
    (name) => name !== LESSON_CLASS_ROUTE_NAMES.MAIN,
  ),
};

export const rememberClassroomTab = (
  section: ClassroomSection,
  routeName: unknown,
): void => {
  if (typeof routeName !== "string") {
    return;
  }
  if (TAB_ROUTE_NAMES[section].includes(routeName)) {
    localStorage.setItem(STORAGE_KEY, routeName);
  }
};

export const getRememberedClassroomTab = (
  section: ClassroomSection,
): string | null => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored !== null && TAB_ROUTE_NAMES[section].includes(stored)) {
    return stored;
  }
  return null;
};

/**
 * Records every confirmed navigation to a classroom tab, feeding the MAIN
 * redirects above. rememberClassroomTab rejects all other route names, so
 * this hook is a no-op outside the classroom sections.
 */
export const registerClassroomTabPersistence = (router: Router): void => {
  router.afterEach((to) => {
    rememberClassroomTab("mentor", to.name);
    rememberClassroomTab("lesson", to.name);
  });
};
